// extracted by mini-css-extract-plugin
export default {"croppablePreview":"src-signer-app-signature-modal-upload-croppable-module__croppablePreview--3vWSG"};